import _ from 'lodash';

import utils from '@utils';

export const onChangeDate = (props: any) => async (event: any) => {
  const inputElement = event.originalEvent.target as HTMLInputElement;
  props.form.setFieldTouched(props.field.name);

  // 日付選択と同時に災害通知履歴詳細を検索する
  const search = async (value: any) => {
    // 正しい日付が入力されていなければ即時returnする

    if (
      props.form.errors[props.field.name] &&
      !utils.date.validateFormat(value, 'YYYY/MM/DD')
    ) {
      return;
    }

    const currentDateTime = utils.date.getNow('YYYY年MM月DD日 HH時mm分ss秒');
    let currentDate = utils.date.format(value, 'YYYY/MM/DD', true);
    if (!currentDate) {
      return;
    }

    if (props.isSearch) {
      props.form.setSubmitting(true);

      const notification = await props.actions.notifications.getSummarizedNotification(
        {
          teamId: props.me.teamId,
          currentDate,
          traceDuration: props.form.values.traceDuration,
        }
      );
      props.actions.notifications.updateSearchTime(currentDateTime);
      props.actions.notifications.clearDetailSort();

      let isAnswered: any;
      // 未回答にチェックが入っている場合、isAnsweredをfalseにする
      if (props.form.values.unAnswered) {
        isAnswered = !props.form.values.unAnswered;
      }
      if (props.form.values.answered) {
        isAnswered = props.form.values.answered;
      }
      // 回答済み、未回答が両方チェックの時、パラメーターを渡さないようにする
      if (props.form.values.unAnswered && props.form.values.answered) {
        isAnswered = undefined;
      }
      // 検索対象のユーザー名の配列を作成
      const names = props.form.values.userNames.map((user: any) => user.text);
      // 検索対象の役職の配列を作成
      const positions = props.form.values.positions.map(
        (position: any) => position.text
      );
      // 検索対象の組織の配列を作成
      const organizations = props.form.values.organizations.map(
        (organization: any) => organization.text
      );

      if (notification.value.detail.data.notificationIds) {
        await props.actions.notifications.updateCurrentNotificationDetail({
          page: 1,
          sort: '-replyDatetime',
          notificationId: notification.value.detail.data.notificationIds,
          teamId: props.me.teamId,
          isSafe: props.form.values.isSafe,
          isMinorInjury: props.form.values.isMinorInjury,
          isSeriousInjury: props.form.values.isSeriousInjury,
          isAnswered,
          name: names,
          position: positions,
          organization: organizations,
        });
      }
      props.form.setSubmitting(false);

      // 検索条件をStoreに保存
      props.actions.notifications.updateDetailSearchWords({
        names,
        positions,
        organizations,
        isAnswered,
        isSafe: props.form.values.isSafe,
        isMinorInjury: props.form.values.isMinorInjury,
        isSeriousInjury: props.form.values.isSeriousInjury,
      });
    } else {
      return;
    }
  };

  const isValidFormat = (date: Date | string) =>
    utils.date.validateFormat(date, 'YYYY/MM/DD');

  // カレンダーで選択した日付を入力
  if (_.isUndefined(inputElement.value) && isValidFormat(event.value as any)) {
    props.form.setFieldValue(props.field.name, event.value);
    search(event.value);
    return;
  }

  // 直接入力で日付を入力
  if (isValidFormat(inputElement.value)) {
    props.form.setFieldValue(props.field.name, new Date(inputElement.value));
    search(new Date(inputElement.value));
  } else {
    props.form.setFieldValue(props.field.name, inputElement.value);
    search(inputElement.value);
  }
};
